var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7249 11.5587L8.60825 9.46699L8.63325 9.44199C10.045 7.87291 11.0998 6.01637 11.7249 4.00033H14.1666V2.33366H8.33325V0.666992H6.66659V2.33366H0.833252V3.99199H10.1416C9.58325 5.60033 8.69992 7.12533 7.49992 8.45866C6.72492 7.60033 6.08325 6.65866 5.57492 5.66699H3.90825C4.51659 7.02533 5.34992 8.30866 6.39159 9.46699L2.14992 13.6503L3.33325 14.8337L7.49992 10.667L10.0916 13.2587L10.7249 11.5587ZM15.4166 7.33366H13.7499L9.99992 17.3337H11.6666L12.5999 14.8337H16.5583L17.4999 17.3337H19.1666L15.4166 7.33366ZM13.2333 13.167L14.5833 9.55866L15.9333 13.167H13.2333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangIcon);
export default __webpack_public_path__ + "static/media/lang_icon.ae71a4cdff0753cdc4f4effabb3902bf.svg";
export { ForwardRef as ReactComponent };